// extracted by mini-css-extract-plugin
export default {"copyPaste":"GitlabInstructionModal-module__copyPaste--T2NmJ"};